import {
    reportAnIssueText,
    foundNewEventsText,
    feedbackUsefulText,
    feedbackNotUsefulText,
    userVoiceFeedbackText,
    disclaimerText,
    invoiceDisclaimerTextIntelligentTech,
    invoiceDisclaimerTextNotTrackingActivity,
} from '../strings.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47648 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { observer } from 'mobx-react';
import { TxpObject, TxpDatapoint } from 'txp-data';
import FeedbackButtonStatus from '../store/viewSchema/FeedbackButtonStatus';
import getFeedbackButtonStatus from '../utils/view/getFeedbackButtonStatus';
import getOriginFromTxpObject from '../utils/view/getOriginFromTxpObject';
import getUserVoiceButtonColorStyle from '../utils/view/getUserVoiceButtonColorStyle';
import onReportIssueHandler from '../utils/actions/onReportIssueHandler';
import onSendFeedbackHandler from '../utils/actions/onSendFeedbackHandler';
import onSentimentFeedbackClickedHandler from '../utils/actions/onSentimentFeedbackClickedHandler';
import TailoredActionName from '../store/schema/telemetry/TailoredActionName';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import UserVoiceDisclaimerDialog from 'owa-txp/lib/components/UserVoiceDisclaimerDialog';
import { isInvoiceEntity } from 'owa-txp/lib/utils/view/entityCheckHelpers';
import TxpDataPointNames from 'owa-txp/lib/store/schema/telemetry/TxpDataPointNames';
import populateFeedbackDataPoint from 'owa-txp/lib/utils/telemetry/populateFeedbackDataPoint';

let styles = require('./Txp.scss');
const classNames = require('classnames');

export interface UserVoiceProps {
    entityNamesMap: number;
    datapointLogger: (txpDatapoint: TxpDatapoint, datapointName: string) => void;
    colorScheme?: ColorScheme;
    // optional props to specify what text and buttons be shown
    userVoiceMessageText?: string;
    // These extra details are needed when user clicks "Report Issue"
    feedbackLocationName?: string;
    txpObject?: TxpObject;
    txpStatusObject?: TxpStatus;
    txpConfiguration?: TxpConfiguration;
    itemId?: string;
    internetMessageId?: string;
}

export interface UserVoiceState extends React.HTMLProps<HTMLDivElement> {
    buttonSet?: FeedbackButtonStatus;
}

@observer
export default class UserVoice extends React.Component<UserVoiceProps, UserVoiceState> {
    private origin: string;

    constructor(props: UserVoiceProps) {
        super(props);
        this.state = {
            buttonSet: getFeedbackButtonStatus(props.txpStatusObject),
        };
        this.origin = getOriginFromTxpObject(props.txpObject);
    }

    UNSAFE_componentWillReceiveProps(newProps: UserVoiceProps) {
        this.setState({
            buttonSet: getFeedbackButtonStatus(newProps.txpStatusObject),
        });
        this.origin = getOriginFromTxpObject(newProps.txpObject);
    }

    render() {
        const { buttonSet } = this.state;
        const { colorScheme } = this.props;
        const userVoiceMessageText = this.props.userVoiceMessageText || loc(foundNewEventsText);
        const buttonStyle = classNames(
            styles.userVoiceButton,
            getUserVoiceButtonColorStyle(colorScheme)
        );

        const showDisclaimerLink = this.props.txpConfiguration
            ? this.props.txpConfiguration.isInvoiceEnabled &&
              isInvoiceEntity(this.props.entityNamesMap)
            : false;

        return (
            <div className={styles.userVoiceContainer}>
                {this.DisclaimerLabelOrButton(
                    showDisclaimerLink,
                    userVoiceMessageText,
                    buttonStyle
                )}

                {buttonSet === FeedbackButtonStatus.defaultState && (
                    <div className={styles.userVoiceButtonsContainer}>
                        <DefaultButton className={buttonStyle} onClick={this.onUseful}>
                            {loc(feedbackUsefulText)}
                        </DefaultButton>
                        <div className={styles.smallText}>|</div>
                        <DefaultButton className={buttonStyle} onClick={this.onNotUseful}>
                            {loc(feedbackNotUsefulText)}
                        </DefaultButton>
                    </div>
                )}
                {buttonSet === FeedbackButtonStatus.sendFeedback && (
                    <DefaultButton className={buttonStyle} onClick={this.onSendFeedbackClicked}>
                        {loc(userVoiceFeedbackText)}
                    </DefaultButton>
                )}
                {(buttonSet === FeedbackButtonStatus.reportIssue ||
                    buttonSet === FeedbackButtonStatus.teeTriggeredReportIssue) && (
                    <DefaultButton className={buttonStyle} onClick={this.onReportIssueClicked}>
                        {loc(reportAnIssueText)}
                    </DefaultButton>
                )}
            </div>
        );
    }

    private DisclaimerLabelOrButton = (
        showDisclaimerLink: boolean,
        userVoiceMessageText: string,
        buttonStyle: any
    ): JSX.Element => {
        if (!showDisclaimerLink) {
            return <label className={styles.smallText}>{userVoiceMessageText}</label>;
        }
        return (
            <DefaultButton className={buttonStyle} onClick={this.onDisclaimerClicked}>
                {loc(disclaimerText)}
            </DefaultButton>
        );
    };

    private onUseful = () => {
        const { datapointLogger, entityNamesMap, txpConfiguration } = this.props;
        this.setState({
            buttonSet: FeedbackButtonStatus.sendFeedback,
        });
        onSentimentFeedbackClickedHandler(
            true,
            datapointLogger,
            entityNamesMap,
            this.origin,
            txpConfiguration
        );
    };

    private onNotUseful = () => {
        const { datapointLogger, entityNamesMap, txpConfiguration } = this.props;
        this.setState({
            buttonSet: FeedbackButtonStatus.reportIssue,
        });
        onSentimentFeedbackClickedHandler(
            false,
            datapointLogger,
            entityNamesMap,
            this.origin,
            txpConfiguration
        );
    };

    private onSendFeedbackClicked = () => {
        const { datapointLogger, entityNamesMap, txpStatusObject, txpConfiguration } = this.props;
        onSendFeedbackHandler(
            datapointLogger,
            entityNamesMap,
            this.origin,
            txpStatusObject,
            txpConfiguration
        );
    };

    private onReportIssueClicked = () => {
        const {
            entityNamesMap,
            feedbackLocationName,
            datapointLogger,
            txpObject,
            txpStatusObject,
            itemId,
            internetMessageId,
            txpConfiguration,
        } = this.props;
        const feedbackType =
            this.state.buttonSet === FeedbackButtonStatus.reportIssue
                ? TailoredActionName.ReportAnIssue
                : TailoredActionName.TeeTriggeredDonation;
        onReportIssueHandler(
            feedbackType,
            feedbackLocationName,
            datapointLogger,
            txpObject,
            txpStatusObject,
            itemId,
            internetMessageId,
            entityNamesMap,
            txpConfiguration
        );
    };

    private onDisclaimerClicked = () => {
        const { datapointLogger, entityNamesMap, txpConfiguration } = this.props;

        let dialogDiv = document.createElement('div');
        document.body.appendChild(dialogDiv);
        ReactDOM.render(
            <UserVoiceDisclaimerDialog
                title={loc(disclaimerText)}
                disclaimerLine1={loc(invoiceDisclaimerTextIntelligentTech)}
                disclaimerLine2={loc(invoiceDisclaimerTextNotTrackingActivity)}
                onClose={() => {
                    ReactDOM.unmountComponentAtNode(dialogDiv);
                    document.body.removeChild(dialogDiv);
                    dialogDiv = null;
                }}
            />,
            dialogDiv
        );

        if (datapointLogger) {
            // Logging Txp Status data only for report issue datapoints. So sending null here.
            const dataPoint = populateFeedbackDataPoint(
                TailoredActionName.DisclaimerViewed,
                entityNamesMap,
                this.origin,
                null /*txpStatus*/,
                txpConfiguration
            );

            datapointLogger(dataPoint, TxpDataPointNames.TXPUserVoice);
        }
    };
}
